export default "__VITE_ASSET__DoHWES5n__"